<!--<pane-back-button backToRightPane="profile-edit"></pane-back-button>-->
<div class="pane-content">
    <p>edit-profile-crop-image works!</p>
    <ngx-smart-cropper
            [imageType]="'jpeg'"
            [aspectRatio]="1"
            [cropX]="50"
            [cropY]="50"
            [cropWidth]="250"
            [cropHeight]="250"
            [theme]="'light'"
            [imageSource]="imageSource"
            (imageCroppedEvent)="imageCropped($event)"
    ></ngx-smart-cropper>

    <img [src]="croppedImage" />
</div>
